var _path, _path2, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4Start(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 170,
    viewBox: "0 0 171 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.001 112.16V111.66H126.501H109.742V31.3647V30.8647H109.242H77.1897H76.9475L76.7973 31.0549L1.31243 126.644L1.20483 126.78V126.954V146.678V147.178H1.70483H66.6377V166.593V167.093H67.1377H109.242H109.742V166.593V147.178H126.501H127.001V146.678V112.16ZM71.9482 86.9417V114.315H51.8153L71.9482 86.9417Z",
    stroke: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3552_31224",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 31,
    width: 126,
    height: 136
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.242 112.16H126.501V146.678H109.242V166.593H67.1377V146.678H1.70483V126.954L77.1897 31.3647H109.242V112.16ZM50.8269 114.815H72.4482V85.418L50.8269 114.815Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3552_31224)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3552_31224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8328 25.2264C24.1933 18.9087 35.8715 22.9291 42.1893 23.3121C50.9957 23.9502 70.3317 26.2603 77.2238 30.3955C85.8388 35.5646 88.902 54.7092 90.2421 65.6216C91.5822 76.534 82.5843 103.528 74.3521 108.123C66.1199 112.717 48.3155 102.954 40.8491 93.1898C33.3827 83.4261 45.4438 75.5768 46.0181 73.2794C46.5925 70.9821 46.9753 58.7295 42.1893 54.7092C37.4032 50.6888 21.5131 45.3283 14.8125 39.0106C8.11189 32.6929 13.4724 31.5442 18.8328 25.2264Z",
    fill: "#3538CD"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_3552_31224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.242 112.16H126.501V146.678H109.242V166.593H67.1377V146.678H1.70483V126.954L77.1897 31.3647H109.242V112.16ZM50.8269 114.815H72.4482V85.418L50.8269 114.815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.001 112.16V111.66H126.501H109.742V31.3647V30.8647H109.242H77.1897H76.9475L76.7973 31.0549L1.31243 126.644L1.20483 126.78V126.954V146.678V147.178H1.70483H66.6377V166.593V167.093H67.1377H109.242H109.742V166.593V147.178H126.501H127.001V146.678V112.16ZM71.9482 86.9417V114.315H51.8153L71.9482 86.9417Z",
    stroke: "#111517"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3552_31224",
    x: -63.5631,
    y: -53.5487,
    width: 229.187,
    height: 238.09,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.6243,
    result: "effect1_foregroundBlur_3552_31224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_3552_31224",
    x: -4.71404,
    y: 24.9459,
    width: 137.634,
    height: 148.066,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.70944
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3552_31224"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_3552_31224",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Start);
export default __webpack_public_path__ + "static/media/4__start.8c01bfd3a7137189d8bdbb2c3d32f0ce.svg";
export { ForwardRef as ReactComponent };